/**
 * @deprecated Use the generic mock output instead
 */
export var FlowRunExecutionMode;
(function (FlowRunExecutionMode) {
    FlowRunExecutionMode["Live"] = "LIVE";
    FlowRunExecutionMode["Test"] = "TEST";
})(FlowRunExecutionMode || (FlowRunExecutionMode = {}));
//# sourceMappingURL=executionMode.js.map